<template>
    <div>
        <div v-if="productsSold.length > 0">
            <p>
                Out of {{products.length}} products, {{ productsSold.length }} have been purchased at least once and
                {{ products.length - productsSold.length }} products have never been purchased once.
            </p>
            <br/>
            <a class="button is-primary pull-right" :href="'/api/reports/products?company='+reportCompany">Download in Excel</a>
            <data-table :data-set="productsSold" :page-length="50" :columns="[
                {name: 'SKU', prop: 'sku', type: 'text'},
                {name: 'Pack Count', prop: 'sold', type: 'number'},
                {name: 'Shipping', prop: 'shipping', type: 'number'},
                {name: 'Subtotal', prop: 'subtotal', type: 'number'},
                {name: 'Total', prop: 'total', type: 'number'},
            ]">
                <template slot="column_Shipping" slot-scope="props">
                    {{ props.row.shipping | currency }}
                </template>
                <template slot="column_Subtotal" slot-scope="props">
                    {{ props.row.subtotal | currency }}
                </template>
                <template slot="column_Total" slot-scope="props">
                    {{ props.row.total | currency }}
                </template>
            </data-table>
        </div>
        <div v-else>
            0 results to show for this company and time period
        </div>
    </div>
</template>

<script>
    import * as reportsAPI from "../../store/api/reports"
    import {mapGetters} from "vuex"
    export default {
        name: 'all-reports',
        data () {
            return {
                productsSold: [],
            }
        },
        mounted() {
            this.getProductSoldCounts()
        },
        computed: mapGetters(['products', 'reportCompany', 'reportStartDate', 'reportEndDate']),
        methods: {
            getProductSoldCounts() {
                reportsAPI.getProductSoldCounts(this.$store.commit, {
                    company: this.reportCompany,
                    start_date: this.reportStartDate,
                    end_date: this.reportEndDate,
                })
                    .then(data => {
                        this.productsSold = data
                    })
            }
        },
        watch: {
            'reportCompany': 'getProductSoldCounts',
            'reportStartDate': 'getProductSoldCounts',
            'reportEndDate': 'getProductSoldCounts'
        }
    }
</script>



// WEBPACK FOOTER //
// SalesByPack.vue?4626fb5b